module.exports = __webpack_public_path__ + "img/0-Main-title.536d47ef.svg";